module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-19-a36251d2e2d5fc239fc75eacde80acbe.jpg";